import { CALL_API, Schemas } from '../../common/middleware/api';

export const TERMS_REQUEST = 'TERMS_REQUEST';
export const TERMS_SUCCESS = 'TERMS_SUCCESS';
export const TERMS_FAILURE = 'TERMS_FAILURE';

export const TERMS_UNPAGED_REQUEST = 'TERMS_UNPAGED_REQUEST';
export const TERMS_UNPAGED_SUCCESS = 'TERMS_UNPAGED_SUCCESS';
export const TERMS_UNPAGED_FAILURE = 'TERMS_UNPAGED_FAILURE';

export const TERM_FETCH_REQUEST = 'TERM_GET_REQUEST';
export const TERM_FETCH_SUCCESS = 'TERM_GET_SUCCESS';
export const TERM_FETCH_FAILURE = 'TERM_GET_FAILURE';

export const TERM_CREATE_REQUEST = 'TERM_CREATE_REQUEST';
export const TERM_CREATE_SUCCESS = 'TERM_CREATE_SUCCESS';
export const TERM_CREATE_FAILURE = 'TERM_CREATE_FAILURE';

export const TERM_UPDATE_REQUEST = 'TERM_UPDATE_REQUEST';
export const TERM_UPDATE_SUCCESS = 'TERM_UPDATE_SUCCESS';
export const TERM_UPDATE_FAILURE = 'TERM_UPDATE_FAILURE';

export const loadTerms = (options) => ({
	[CALL_API]: {
		types: [TERMS_REQUEST, TERMS_SUCCESS, TERMS_FAILURE],
		endpoint: 'api/terms',
		request: options,
		schema: Schemas.TERM_ARRAY
	}
});

export const loadUnpagedTerms = (options, onSuccessEvent, onErrorEvent) => ({
	[CALL_API]: {
		types: [TERMS_UNPAGED_REQUEST, TERMS_UNPAGED_SUCCESS, TERMS_UNPAGED_FAILURE],
		endpoint: 'api/terms/unpaged',
		request: options,
		schema: Schemas.TERM_ARRAY,
		onSuccessEvent,
		onErrorEvent
	}
});

export const fetchTerm = (id) => ({
	[CALL_API]: {
		types: [TERM_FETCH_REQUEST, TERM_FETCH_SUCCESS, TERM_FETCH_FAILURE],
		endpoint: `api/terms/${id}`,
		schema: Schemas.TERM
	}
});

export const createTerm = (term, history) => ({
	[CALL_API]: {
		types: [TERM_CREATE_REQUEST, TERM_CREATE_SUCCESS, TERM_CREATE_FAILURE],
		endpoint: 'api/terms',
		method: 'POST',
		request: term,
		schema: Schemas.TERM,
		form: 'newTerm',
		transition: {
			history,
			successPath: (response) => {
				return `/terms/${response.result}`;
			}
		}
	}
});

export const updateTerm = (id, term) => ({
	[CALL_API]: {
		types: [TERM_UPDATE_REQUEST, TERM_UPDATE_SUCCESS, TERM_UPDATE_FAILURE],
		endpoint: `api/terms/${id}`,
		method: 'PUT',
		request: term,
		schema: Schemas.TERM,
		form: 'term'
	}
});

//get first started current term or first future term
export const getDefaultActiveTerm = (terms) => {
	return Object.values(terms).sort((a, b) => new Date(a.startDate) > new Date(b.startDate) ? 1 : -1).find(term => term.active);
};

export const getLastTerm = (terms) => {
	if (!terms || terms.length === 0) {
		return null;
	}

	return Object.values(terms).sort((a, b) => new Date(a.startDate) > new Date(b.startDate) ? -1 : 1)[0];
};